/**
 * Constants for secret field names
 * @readonly
 * @enum {string}
 */
export const SECRET_FIELDS = {
    SUBMISSION_PASSWORD: 'submissionPassword',
    SUBMISSION_EMAIL_PASSWORD: 'submissionEmailPassword',
};
